import {
  Non_Billable_Tasks,
  ONBOARDING_TASKS,
  TASK_TYPE_TO_SHOW,
  Tcm_TASKS,
} from 'src/constant/taskType';
import {TaskFilter} from './TaskFilter';

export const taskCategories = user => {
  const taskTypes = TaskFilter({user}).taskTypes;
  const nonBillableTasks = taskTypes.filter(type =>
    Non_Billable_Tasks.includes(type),
  );
  const onBoardingTasks = taskTypes.filter(type =>
    ONBOARDING_TASKS.includes(type),
  );

  const TCM_TASK = Object.keys(Tcm_TASKS);
  const otherTasks = taskTypes.filter(type => TCM_TASK.includes(type));

  return [
    ...otherTasks.map(type => ({
      key: type,
      title: TASK_TYPE_TO_SHOW[type] || type,
      taskType: type,
      filter: JSON.stringify({type}),
      eventSourceId: type,
      reduxKey: type,
    })),
    {
      key: 'non-billable',
      title: 'Non-Billable',
      taskType: 'non-billable',
      filter: {
        type: `{$in:${JSON.stringify(nonBillableTasks)}}`,
      },
      eventSourceId: 'tcmtask',
      reduxKey: 'non-billable',
    },
    {
      key: 'onboarding',
      title: 'Onboarding Tasks',
      taskType: 'onboarding',
      filter: {
        type: `{$in:${JSON.stringify(onBoardingTasks)}}`,
      },
      eventSourceId: 'tcmtask',
      reduxKey: 'onboarding',
    },
  ];
};
